export enum ChannelTypeE {
  WIDGET = 'widget',
  WHATSAPP = 'whatsapp',
  WHATSAPP_OFICIAL = 'whatsapp-oficial',
  EXTERNAL_CHAT = 'external-chat',
  FACEBOOK = 'facebook-messenger',
  INSTAGRAM = 'instagram-direct',
  INTERNAL = 'internal',
  TELEGRAM = 'telegram',
  EMAIL = 'email',
  EMAIL_SES = 'email-ses',
  RECLAME_AQUI = 'reclame-aqui',
  LINKEDIN = 'linkedin',
  RCS = 'rcs',
  MS_TEAMS = 'ms-teams',
}

export enum StartFlowStrategyE {
  FLOW = 'flow',
  AI_AGENT = 'ai_agent',
}

// Mirrors MsTeamsPairingStatusE of the shared module. PENDING is the state the channel is
// born in; ACTIVE is reached when a tenant admin types the activation code in the bot chat.
export enum MsTeamsPairingStatusE {
  PENDING = 'pending',
  ACTIVE = 'active',
  REVOKED = 'revoked',
}
